import { faSearch, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./columnSearch.css";
import React from "react";
const ColumnSearch = (props) => {
  const { isSearching, label,onClickSearch,onChange,value,onClickClose }=props
  return (
    <div className="flex">
      {isSearching && (
        <div className="flex input-search-white">
          <input onChange={onChange} value={value} placeholder="Escriba aquí"  type="text" />
          &nbsp;
          <FontAwesomeIcon className="blue cursor-pointer margin-auto" onClick={onClickClose} icon={faX} />
        </div>
      )}
      {!isSearching && label}
      &nbsp;
      <div className="flex margin-auto">
        {!isSearching && (
          <FontAwesomeIcon className="blue cursor-pointer" onClick={onClickSearch} icon={faSearch} />
        )}
      </div>
    </div>
  );
};

export default ColumnSearch;
